/** The strings for this feature, in the active language — see src/lib/i18n.js. */
import { pickLocale } from '../../lib/i18n'
import * as ar from './strings.ar'
import * as en from './strings.en'

export const systemStateStrings = pickLocale(ar.systemStateStrings, en.systemStateStrings)
export const notificationsLogStrings = pickLocale(ar.notificationsLogStrings, en.notificationsLogStrings)
